import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

export const ConfirmModal = ({
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColorScheme = "red",
  trigger, // any JSX element (button, icon, etc.)
  onConfirm,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  return (
    <>
      {/* Trigger element */}
      <span onClick={onOpen} style={{ display: "inline-block" }}>
        {trigger}
      </span>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />

          <ModalBody>{message}</ModalBody>

          <ModalFooter>
            <Button variant="ghost" borderRadius={'full'} mr={3} onClick={onClose}>
              {cancelText}
            </Button>
            <Button colorScheme={confirmColorScheme} borderRadius={'full'} onClick={handleConfirm}>
              {confirmText}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
